import { Dispatch, FC, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { Select } from '../../../../../../components/UI/Select'
import { FormProvider, useForm } from 'react-hook-form'
import { InputNumberDocGet } from '../../../../../../components/UI/Input'
import { useGuest } from '../../../../hooks'
import useMasterListService from '../../../../../central/hooks/useMasterService'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  funcSearch: (e: any) => void
  idCampamento: string
}

const ModalSearch: FC<Props> = ({ show, setShow, funcSearch, idCampamento }) => {
  const { getGuestsServiceData } = useGuest()
  const { getMasterData } = useMasterListService()
  const [textMessage, setTextMessage] = useState('')
  const [maxLength, setMaxLength] = useState('8')
  const [minLength, setMinLength] = useState('8')
  const [docType, setDocType] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null) // Ref para el campo de entrada
  const methods = useForm()
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = methods
  let numeroDocumentoChangeTimeout: any
  const numeroDocumento = watch('numeroDocumento')
  const tipoDocumento = watch('tipoDocumentoId')
  console.log(tipoDocumento)
  const tipoDocumentoNombre = watch('tipoDocumentoNombre')
  const handleNumeroDocumentoChange = useCallback(
    (value: string, docType: any[]) => {
      setValue('numeroDocumento', value)
      setTextMessage('')
      // Realizar la acción deseada después de 2 segundos sin cambios
      clearTimeout(numeroDocumentoChangeTimeout)
      numeroDocumentoChangeTimeout = setTimeout(() => {
        if (value?.length > 0) {
          // Realizar la acción deseada después de 2 segundos sin cambios
          const input = document.querySelector('input[name="numeroDocumento"]')
          if (input) {
            input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter' }))
            input.addEventListener('keydown', handleEnterKey as EventListener)
          }
        }
      }, 2000)
    },
    [setValue, tipoDocumento],
  )

  const handleEnterKey = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      let numDOc = numeroDocumento || ''
      if (tipoDocumento === '00' && numDOc.length <= Number(maxLength)) {
        setLoading(true)
        filterUser()
      } else {
        if (Number(minLength) <= numDOc.length && numDOc.length <= Number(maxLength)) {
          setLoading(true)
          filterUser()
        }
      }
      const input = document.querySelector('input[name="numeroDocumento"]')
      if (input) {
        input.removeEventListener('keydown', handleEnterKey as EventListener)
      }
    }
  }

  const isEmptyOrNull = (value: any) => {
    return (value || "").length <= 1
  }

  useEffect(() => {
    if (docType.length > 0) {
      handleNumeroDocumentoChange(numeroDocumento, docType)
    }
    const input = document.querySelector('input[name="numeroDocumento"]')
    if (input) {
      input.addEventListener('keydown', handleEnterKey as EventListener)
    }
    return () => {
      if (input) {
        input.removeEventListener('keydown', handleEnterKey as EventListener)
      }
    }
  }, [numeroDocumento, handleNumeroDocumentoChange, docType])

  const handleClose = () => {
    setShow(false)
    setValue('numeroDocumento', '')
    setTextMessage('')
  }
  const getDocTypeList = async () => {
    try {
      const response = await getMasterData('TipoDocumento')
      const data = response
      const filterData = data.filter(
        (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
      )
      const mappedMaster = filterData.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        minLength: master.campoadicionaltxt1,
        maxLength: isEmptyOrNull(master.campoadicionaltxt5) ? master.campoadicionaltxt1 : master.campoadicionaltxt5,
      }))
      setDocType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const filterUser = async () => {
    const filterUser =
      (await getGuestsServiceData({
        pageNumber: 1,
        size: 100,
        TipoDocumento_descripcion: tipoDocumentoNombre || '',
        NumeroDocumento: numeroDocumento || '',
        isCombo: true,
        CampamentoId: idCampamento,
      })) || []
    if (filterUser.length > 0) {
      setLoading(false)
      funcSearch(filterUser[0])
      handleClose()
      setTextMessage('')
    } else {
      setLoading(false)
      setTextMessage('No se encontró resultados')
    }
  }
  useEffect(() => {
    setValue('tipoDocumentoId', '01')
    setValue('tipoDocumentoNombre', 'DNI')
    setMinLength('8')
    setMaxLength('8')
    getDocTypeList()
  }, [])
  useEffect(() => {
    // Enfocar el campo de entrada cuando el modal se muestra
    if (show && inputRef.current) {
      inputRef.current.focus()
    }
  }, [show, inputRef])

  const handleGetType = (e: any) => {
    let value = e ? e.value : ''
    let name = e ? e.label : ''
    setValue('tipoDocumentoId', value)
    setValue('tipoDocumentoNombre', name)
    setMinLength(e.minLength)
    setMaxLength(e.maxLength)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Ingresar o Scanear el Número de documento</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <FormProvider {...methods}>
              <form>
                <div className='col-lg-12'>
                  <label className='required'>Tipo de Documento:</label>
                  <Select
                    control={control}
                    name='tipoDocumentoId'
                    data={docType}
                    errors={errors}
                    onChangeValue={handleGetType}
                  />
                </div>
                <div className='col-lg-12'>
                  <div className='d-flex'>
                    <label className='required'>Número de Documento:</label>
                    {loading && (
                      <div className='loader-icon me-2'>
                        <div className='icon-container'>
                          <i className='loader'></i>
                        </div>
                      </div>
                    )}
                  </div>

                  <InputNumberDocGet
                    name='numeroDocumento'
                    textPlaceholder='Escribe el documento'
                    register={register}
                    ref={inputRef}
                    errors={errors}
                    typeDoc={watch('tipoDocumentoId')}
                  />
                </div>
              </form>
            </FormProvider>
          </div>
          <p
            style={{
              color: 'red',
              fontWeight: 600,
            }}
          >
            {textMessage}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export { ModalSearch }
